export const insertSeparator = <T, S>(arr: T[], separator: S): Array<T | S> =>
  arr.reduce((acc, cur) => [...acc, cur, separator], [] as Array<T | S>).slice(0, -1);
